import {Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {
    ICacheManager,
    ICustomerPortalService,
    Policy,
    POLICY_STATUS_PENDING_RENEWAL,
    PolicyProperty,
    PolicyPropertyEnum,
    productHelper,
    ProductsEnum,
    Renewal, resourcesHelper,
    Types
} from "@falcon/services";
import * as React from "react";
import {Checkbox} from "../../../../../../components/inputs/Checkbox";
import {AutomaticRenewalCancellationConfirmationModal, AutoRenewalBenefits} from "@falcon/plugin-falcon-journey";
import {RenewalPreferences} from "../../../../../../components/enums/enums";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import {FalconAccordion} from "../../../../../../components/FalconAccordion";
import {AutomaticRenewalSuccessModal} from "../../../../../../components/modals/AutomaticRenewalSuccessModal";
import * as moment from "moment";
import {GracePeriodModal} from "../../../../../../components/modals/GracePeriodModal";
import {NavigateFunction} from "react-router-dom";

interface IAutomaticRenewalCheckboxSectionProps {
    activeAnnualPolicy?: Policy;
    navigate: NavigateFunction;
    product: ProductsEnum;
}

interface IAutomaticRenewalCheckboxSectionState {
    automaticRenewal?: boolean;
    performRenewal?: boolean;
    loading: boolean;
    showModal: boolean;
    renewalType: string;
    tmpRenewalType: string;
    showProposeModal: boolean;
    showSuccessModal: boolean;
    renewalPeriod: boolean;
    showGracePeriodBanner: boolean;
    gracePeriod: boolean;
    renewalProposal?: Renewal;
    productWording: string;
}

export class AutomaticRenewalCheckboxSection extends React.Component<IAutomaticRenewalCheckboxSectionProps, IAutomaticRenewalCheckboxSectionState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    constructor(props: IAutomaticRenewalCheckboxSectionProps) {
        super(props);

        this.state = {
            loading: false,
            showModal: false,
            showProposeModal: false,
            showSuccessModal: false,
            renewalType: "",
            tmpRenewalType: "",
            renewalPeriod: false,
            showGracePeriodBanner: false,
            gracePeriod: false,
            productWording: this.props.product === ProductsEnum.HOME ?
                `${resourcesHelper.PRODUCT} Home Insurance policy` : `${resourcesHelper.PRODUCT} Car Insurance policy`
        };

        this.showProposeModal = this.showProposeModal.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.changeTmpRenewalType = this.changeTmpRenewalType.bind(this);
        this.updateRenewalType = this.updateRenewalType.bind(this);
        this.setRenewalType = this.setRenewalType.bind(this);
    }

    public componentDidMount = () => {

        this.customerPortalService.getRenewalProposal(this.props.activeAnnualPolicy!.policyNumber).subscribe(
            (renewalProposal: Renewal) => {
                const today = moment().utc().startOf("day");
                const gracePeriod: boolean = renewalProposal != null && today.isSameOrAfter(moment.utc(renewalProposal.headerInfo.startDate).startOf("day"));

                this.setState({renewalProposal, gracePeriod, loading: true});
                const renewalPeriod: boolean = renewalProposal != null && renewalProposal.status === POLICY_STATUS_PENDING_RENEWAL;
                if (renewalPeriod) {
                    this.setState({
                        renewalPeriod: true
                    })
                }
                this.getPolicyProperties(renewalPeriod);

            }
        );
    };

    private getPolicyProperties(renewalPeriod: boolean){
        this.customerPortalService.getPolicyPropertiesByPropertyKeys(this.props.activeAnnualPolicy!.policyNumber,
            [PolicyPropertyEnum.AUTOMATIC_RENEWAL, PolicyPropertyEnum.PERFORM_RENEWAL]).subscribe(
            (properties: PolicyProperty[]) => {
                const updates: any = {};
                properties.forEach(property => {
                    if (property.key === PolicyPropertyEnum.AUTOMATIC_RENEWAL) {
                        updates.automaticRenewal = property ? property.value === "true" : false;
                    } else if (property.key === PolicyPropertyEnum.PERFORM_RENEWAL) {
                        updates.performRenewal = property ? property.value === "true" : false;
                    }

                });
                this.setState({
                    loading: false,
                    performRenewal: updates.performRenewal,
                    automaticRenewal:  updates.automaticRenewal,
                    renewalType: renewalPeriod ? this.setRenewalType(updates.performRenewal, updates.automaticRenewal) : ""
                })

            }
        );
    }

    public componentDidUpdate(prevProps: IAutomaticRenewalCheckboxSectionProps, prevState: IAutomaticRenewalCheckboxSectionState) {
        if (this.state.showProposeModal && !prevState.showProposeModal) {
            this.setState({tmpRenewalType: this.state.renewalType});
        }
    }

    public render = () => {
        if (this.state.renewalPeriod) {
            return this.renderRenewalChoiceInRenewalWindow();
        } else {
            return this.renderRenewalChoice();
        }
    };

    private renderRenewalChoice(): any {
        return (
            <>
                <Overlay show={this.state.loading}/>
                <div className="mt-5 inner-container automatic-renewal-checkbox-section">
                    <h2 className="fs-18 font-family-display font-weight-semi-bold text-blue-2">Auto-renewal makes
                        things a little easier...</h2>
                    <AutoRenewalBenefits/>
                    <div className="expandable-section">
                        <p className="font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0">Prefer not to
                            auto-renew?</p>
                        <div className="widget">
                            <FalconAccordion
                                toggleHidden={this.renderAccordionToggle("expand-icon")}
                                toggleShown={this.renderAccordionToggle("collapse-icon")}
                                togglePositionTop={true}
                            >

                                <div>
                                    <Checkbox
                                        className="ml-0 mt-0"
                                        id="automaticRenewalCheckbox"
                                        name="automaticRenewal"
                                        label={this.getCheckboxLabel()}
                                        value={this.state.performRenewal!}
                                        onChanged={this.handleCheckboxToggle}
                                    />
                                </div>
                            </FalconAccordion>
                        </div>
                    </div>
                </div>
                <AutomaticRenewalCancellationConfirmationModal
                    isOpen={this.state.showModal}
                    onAgreeToAutoRenewal={this.keepRenewalPreferences}
                    onConfirmToCancelAutoRenewal={this.cancelNextYearRenewal}
                    product={this.props.product}
                />
                {this.state.showSuccessModal && !(this.state.showGracePeriodBanner && this.state.gracePeriod) &&
                    <AutomaticRenewalSuccessModal
                        automaticRenewal={this.state.automaticRenewal!}
                        nextYearRenewal={this.state.performRenewal!}
                        product={this.props.product}
                        closeSuccessModal={this.closeSuccessModal}
                    />}
            </>
        )
    }

    private renderRenewalChoiceInRenewalWindow(): any {
        return (
            <>
                {this.renderPerformRenewalCheckboxContent()}
                {this.renderPerformRenewalModal(this.state.showProposeModal)}
            </>
        );
    }

    private renderPerformRenewalCheckboxContent(): any {

        const policyEndDate: any = moment.utc(this.props.activeAnnualPolicy?.endDate, moment.ISO_8601).add(1, 'days').format("DD MMM YYYY");
        const performLabelContent = (
            <>
                {this.state.renewalType !== RenewalPreferences.NO_RENEWAL && <div>
                    <span className="d-block mb-2 font-weight-semi-bold">I confirm that I want my {this.state.productWording} to renew.</span>
                    <span className="d-block font-weight-extra-light banner banner-info">
                        Heads up - your {this.state.productWording} will automatically renew on {policyEndDate}, 00:00. No payment will be taken until then.
                    </span>
                </div>}
                {this.state.renewalType === RenewalPreferences.NO_RENEWAL && <div>
                    <span className="d-block mb-2 font-weight-semi-bold">I confirm that I don't want to renew my {this.state.productWording}.</span>
                    <div className="d-block font-weight-extra-light banner banner-info banner-info-multiple-paragraphs">
                        <p className="grid-col-2">Heads up - <span className="font-weight-semi-bold">you'll no longer be covered starting from {policyEndDate}.</span></p>
                        <div className="grid-col-2 margin-top-16">If you change your mind, you can still renew your policy by choosing to edit renewal preferences below.</div>
                    </div>
                </div>}
                <div>
                    <button type="button"
                            className="btn btn-primary btn-next-no-arrow w-100 edit-renewal-preferences-btn"
                            onClick={this.showProposeModal}>Edit renewal preferences
                    </button>
                </div>
                {this.state.showSuccessModal && !(this.state.showGracePeriodBanner && this.state.gracePeriod) &&
                    <AutomaticRenewalSuccessModal
                        automaticRenewal={this.state.automaticRenewal!}
                        nextYearRenewal={this.state.performRenewal!}
                        product={this.props.product}
                        closeSuccessModal={this.closeSuccessModal}
                    />}
            </>

        );

        return (
            <div className="falcon-checkbox form-group">
                <div className="d-flex">
                    <div className="form-check mr-3">
                        <input className={`custom-control-input true`} type="checkbox"
                               name="performRenewal"
                               id="performRenewal"
                               checked={true}
                        />
                        <label className="custom-control-label" htmlFor="performRenewal">
                            <div className="checkbox-big"/>
                            <div className="checkbox-label">
                                {performLabelContent}
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        );
    }

    private renderPerformRenewalModal(isOpen: boolean): any {
        return (
            <>
                <Modal className="automatic-renewal-modal pb-0" isOpen={isOpen} toggle={this.cancelChanges}
                       id="automaticRenewalModal">
                    <ModalHeader toggle={this.cancelChanges}>
                        <div className="d-flex">
                            <img className="info-icon-selected" src="/img/Flow-info-selected.svg" alt="Info icon"/>
                            <span>Edit your policy renewal preferences</span>
                        </div>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <div className="form-group edit-renewal-preference-modal">
                            <div className="input-group">
                                <label className="modal-header-label">Do you want your {this.state.productWording} to
                                    auto-renew?</label>
                                <div className="custom-control w-100 falcon-custom-radio">
                                    <input
                                        className={"custom-radiobutton cursor-pointer"}
                                        type="radio"
                                        name={"performRenewal-" + RenewalPreferences.RENEWAL_THIS_YEAR}
                                        id={"performRenewal-" + RenewalPreferences.RENEWAL_THIS_YEAR}
                                        value={RenewalPreferences.RENEWAL_THIS_YEAR}
                                        checked={this.state.tmpRenewalType === RenewalPreferences.RENEWAL_THIS_YEAR}
                                        onChange={this.changeTmpRenewalType}
                                    />
                                    <label id={'driver-label'}
                                           className="checkbox-label label-bg-transparent font-weight-semi-bold"
                                           htmlFor={"performRenewal-" + RenewalPreferences.RENEWAL_THIS_YEAR}>
                                        Yes, renew this year only
                                    </label>
                                </div>
                                <div className="custom-control w-100 falcon-custom-radio">
                                    <input
                                        className={"custom-radiobutton cursor-pointer"}
                                        type="radio"
                                        name={"performRenewal-" + RenewalPreferences.RENEWAL_EVERY_YEAR}
                                        id={"performRenewal-" + RenewalPreferences.RENEWAL_EVERY_YEAR}
                                        value={RenewalPreferences.RENEWAL_EVERY_YEAR}
                                        checked={this.state.tmpRenewalType === RenewalPreferences.RENEWAL_EVERY_YEAR}
                                        onChange={this.changeTmpRenewalType}
                                    />
                                    <label id={'driver-label'}
                                           className="checkbox-label label-bg-transparent font-weight-semi-bold"
                                           htmlFor={"performRenewal-" + RenewalPreferences.RENEWAL_EVERY_YEAR}>
                                        Yes, auto-renew every year
                                    </label>
                                </div>
                                <div className="custom-control w-100 falcon-custom-radio">
                                    <input
                                        className={"custom-radiobutton cursor-pointer"}
                                        type="radio"
                                        name={"performRenewal-" + RenewalPreferences.NO_RENEWAL}
                                        id={"performRenewal-" + RenewalPreferences.NO_RENEWAL}
                                        value={RenewalPreferences.NO_RENEWAL}
                                        checked={this.state.tmpRenewalType === RenewalPreferences.NO_RENEWAL}
                                        onChange={this.changeTmpRenewalType}
                                    />
                                    <label id={'driver-label'}
                                           className="checkbox-label label-bg-transparent font-weight-semi-bold"
                                           htmlFor={"performRenewal-" + RenewalPreferences.NO_RENEWAL}>
                                        No, I don't want to auto-renew
                                    </label>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="renewalModalButtonContainer">
                            <button type="button" className="btn btn-primary btn-next-no-arrow w-100"
                                    onClick={this.updateRenewalType}>Save changes
                            </button>
                            <button type="button" className="btn btn-white mb-0 w-100" onClick={this.cancelChanges}
                                    id="noAutoRenewal">Cancel changes
                            </button>
                        </div>
                    </ModalFooter>
                </Modal>
                {this.state.gracePeriod && this.state.showGracePeriodBanner &&
                    <GracePeriodModal
                        currentPolicy={this.props.activeAnnualPolicy!}
                        renewalProposal={this.state.renewalProposal!}
                        hideCloseButton={true}
                        setPerformRenewal={() => {
                        }}
                        showHideWillBeRenewedConfirmation={() => {
                        }}
                        onClose={() => {
                            this.update(false, false);
                            this.setState({showGracePeriodBanner: false, renewalType: RenewalPreferences.NO_RENEWAL})
                        }}
                    />
                }
            </>
        );
    }

    private getCheckboxLabel() {
        return (
            <div><p>By automatically renewing your insurance, you can save time next year and ensure that there's no
                interruption to your cover.</p>
                <p className="mb-1">Untick this button to opt out of automatic renewal.</p></div>
        );
    }

    private renderAccordionToggle(accordionIcon: string) {
        return (
            <div className="toggle text-left mt-0 mb-3 d-flex align-items-center">
                <span className="mr-1">Opt out here</span>
                <span className={`toggle-icon ${accordionIcon}`}/>
            </div>
        )
    }

    private handleCheckboxToggle = (newValue: boolean) => {
        if (newValue) {
            this.setState(
                {
                    automaticRenewal: true,
                    performRenewal: true,
                    showSuccessModal: true
                },
                () => this.update(this.state.automaticRenewal!, this.state.performRenewal!)
            );
        } else {
            this.setState({
                showModal: true
            })
        }
    };

    private keepRenewalPreferences = () => {
        this.setState({
            showModal: false,
            showSuccessModal: true
        });
    };

    private cancelNextYearRenewal = () => {
        if (productHelper.isPolicyInRenewalWindow(this.props.activeAnnualPolicy!)) {
            this.props.navigate(`/dashboard/${this.props.product}/cancel/${this.props.activeAnnualPolicy!.policyNumber}`);
        } else {
            this.setState(
                {
                    automaticRenewal: false,
                    performRenewal: false,
                    showModal: false,
                    showSuccessModal: true
                },
                () => this.update(this.state.automaticRenewal!, this.state.performRenewal!)
            );
        }
    };

    private setRenewalType(performRenewal: boolean, automaticRenewal: boolean): string {
        if (performRenewal) {
            return automaticRenewal ? RenewalPreferences.RENEWAL_EVERY_YEAR : RenewalPreferences.RENEWAL_THIS_YEAR;
        }
        return RenewalPreferences.NO_RENEWAL;
    }

    private showProposeModal = () => {
        this.setState({
            showProposeModal: true
        });
    };

    private cancelChanges = () => {
        this.setState({
            showProposeModal: false
        });
    };

    private changeTmpRenewalType = (event: any) => {
        this.setState({tmpRenewalType: event.target.value});
    };

    private closeSuccessModal = (): void => {
        this.setState({
            showSuccessModal: false
        });
    };

    private updateRenewalType = () => {
        this.setState({renewalType: this.state.tmpRenewalType});
        this.updatePropertyAndState(this.state.tmpRenewalType);
    };

    private updatePropertyAndState(renewalType: string) {
        let automaticRenewal = false;
        let performRenewal = false;
        switch (renewalType) {
            case RenewalPreferences.RENEWAL_THIS_YEAR:
                performRenewal = true;
                break;
            case RenewalPreferences.RENEWAL_EVERY_YEAR:
                automaticRenewal = true;
                performRenewal = true;
                break;
        }

        this.setState({
            showGracePeriodBanner: renewalType !== RenewalPreferences.NO_RENEWAL,
            performRenewal,
            automaticRenewal,
            renewalType,
            showProposeModal: false,
            showSuccessModal: true
        });

        this.update(automaticRenewal, performRenewal);
    }

    private update = (automaticRenewal: boolean, performRenewal: boolean) => {
        this.customerPortalService.storePolicyAutomaticRenewalFlag(this.props.activeAnnualPolicy!.policyNumber, automaticRenewal)
            .subscribe(() => {
                    this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${this.props.activeAnnualPolicy!.policyNumber},automaticRenewal`);
                }
            )

        this.customerPortalService.storePolicyPerformRenewalFlag(this.props.activeAnnualPolicy!.policyNumber, performRenewal)
            .subscribe(() => {
                    this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${this.props.activeAnnualPolicy!.policyNumber},performRenewal`);
                }
            )
    }
}
